import React, { useState,useEffect } from 'react';
import './Commentsection.css';
import { postWithTokenAPI,getWithoutTokenAPI } from '../../util/Api';
import { useSelector } from 'react-redux';
import LoginPopup from "../../Components/Loginpopup/Loginpop";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import users from '../../assets/user.jpeg';
// import { fetchComments } from '../../util/fetchblog';

const LeaveComment = ({ blogId }) => {
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoginPopupOpen, setLoginPopupOpen] = useState(false);

  const accessToken = useSelector((state) => state.auth?.auth?.access_token);
  const [comments, setComments] = useState([]);
  const [visibleCount, setVisibleCount] = useState(3);

  const fetchComments = async () => {
    if (!blogId) return;
    
    try {
      const response = await getWithoutTokenAPI(`/comment/find-all?blog_id=${blogId}`);

      if (response?.statusCode === 200 && response?.data?.comments) {
        const formattedComments = response.data.comments
          .filter(item => item && item._id && !item.is_deleted)
          .map(item => ({
            id: item._id,
            name: item.created_by?.name || 'Unknown',
            date: new Date(item.createdAt).toLocaleDateString('en-US', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            }),
            time: new Date(item.createdAt).toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
            }),
            createdAt: item.createdAt, // Store original date for sorting
            text: item.comment,
            avatar: item.created_by?.profile_image || users,
            blogTitle: item.blog_id?.title || 'Unknown Blog',
            status: item.status,
            isDeleted: item.is_deleted
          }))
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sort by createdAt date

        setComments(formattedComments);
      } else {
        console.error('Failed to load comments', response?.error);
      }
    } catch (error) {
      console.error('Error fetching comments:', error);
    }
  };

  // Function to add a new comment
  const addNewComment = (newComment) => {
    if (!newComment || !newComment._id) return;

    const formattedComment = {
      id: newComment._id,
      name: newComment.created_by?.name || 'Unknown',
      date: new Date(newComment.createdAt).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }),
      time: new Date(newComment.createdAt).toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
      }),
      createdAt: newComment.createdAt, // Store original date for sorting
      text: newComment.comment,
      avatar: newComment.created_by?.profile_image || users,
      blogTitle: newComment.blog_id?.title || 'Unknown Blog',
      status: newComment.status,
      isDeleted: newComment.is_deleted
    };

    setComments(prevComments => {
      // Check if comment already exists
      const exists = prevComments.some(comment => comment.id === formattedComment.id);
      if (exists) {
        return prevComments;
      }
      // Add new comment at the beginning of the array and sort
      const updatedComments = [formattedComment, ...prevComments];
      return updatedComments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    });
  };

  useEffect(() => {
    fetchComments();
  }, [blogId]); // Fetch comments when blogId changes

  // Listen for new comments from other components
  useEffect(() => {
    const handleNewComment = (event) => {
      if (event.detail && event.detail.comment) {
        addNewComment(event.detail.comment);
      }
    };

    window.addEventListener('newComment', handleNewComment);
    return () => {
      window.removeEventListener('newComment', handleNewComment);
    };
  }, []);

  const closeLoginPopup = () => {
    setLoginPopupOpen(false);
  };
  
  const handleSubmit = async () => {
    if (!accessToken) {
      setLoginPopupOpen(true);
      return;
    }

    if (!comment.trim()) {
      toast.error('Comment is required.');
      return;
    }

    setIsSubmitting(true);
    setSuccessMessage('');

    try {
      const payload = {
        blog_id: blogId,
        comment: comment.trim(),
        status: 'Active',
        is_deleted: false
      };

      const res = await postWithTokenAPI(accessToken, '/comment/create', payload);

      if (res?.statusCode === 200 && res?.data) {
        toast.success('Comment posted successfully!');
        setComment('');
        
        // Fetch comments again to get the updated list
        await fetchComments();
        
      } else {
        toast.error('Failed to post comment');
      }
    } catch (error) {
      console.error('Error posting comment:', error);
      toast.error('Failed to post comment');
    } finally {
      setIsSubmitting(false);
    }
  };
    
  return (
    <>
      <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
            />
          {isLoginPopupOpen && <LoginPopup onClose={closeLoginPopup} />}

      <div className="leave-comment-wrapper">
        <h2 className="leave-comment-title">Leave a Comment</h2>

        <div className="input-group message-group">
          <label>Message</label>
          <textarea
            placeholder="Write your comment here…"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>

        <button
          className="submit-btn"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Posting...' : 'Post Comment'}
        </button>

        {successMessage && <div className="success-msg">{successMessage}</div>}
      </div>

      <div className="comments-wrapper">
      <h2 className="comments-title mb-3">Comments</h2>
      {comments.length === 0 ? (
        <p className="no-comments">No comments yet. Be the first to comment!</p>
      ) : (
        <>
          {comments.slice(0, visibleCount).map((comment) => (
            <div key={comment.id} className="comment-group ">
              <img src={comment.avatar} alt={comment.name} className="avatar" />
              <div className="comment-content">
                <div className="comment-header">
                  <span className="name">{comment.name}</span>
                  <span className="dot">•</span>
                  <span className="date">{comment.date}</span>
                  <span className="dot">•</span>
                  <span className="time">{comment.time}</span>
                </div>
                {/* <p className="blog-title">{comment.blogTitle}</p> */}
                <p className="comment-text">{comment.text}</p>
              </div>
              <hr className="divider-command" />
            </div>
          ))}
          {comments.length > visibleCount && (
            <button className='load' onClick={() => setVisibleCount(visibleCount + 3)}>
              Load More
            </button>
          )}
        </>
      )}
    </div>
    </>
  );
};

export default LeaveComment;
